import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import PpwrDashboardService from 'src/modules/3rd-party-management/apis/admin/PpwrDashboardService';
import {
    getPpwrComplianceStatusConfig,
    PPWR_LAST_UPDATED_DATE_FORMAT,
} from 'src/modules/3rd-party-management/constants';
import DateUtils from 'src/services/utils/DateUtils';

export const PPWR_DASHBOARD_SUMMARY_QUERY_KEY = '3rd-party-management-fetch-ppwr-dashboard-summary';

const dateUtils = new DateUtils();

const useSummaryWidgets = ({
    t,
}) => {
    const query = useQuery({
        queryKey: [PPWR_DASHBOARD_SUMMARY_QUERY_KEY],
        queryFn: async () => {
            const service = PpwrDashboardService.getInstance();

            return await service.fetchSummary();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching PPWR dashboard summary data.'), {
                type: 'error',
            });
        },
    });

    const data = query.data;

    if (!data) {
        return {
            ...query,
            widgets: null,
        };
    }

    const complianceConfig = getPpwrComplianceStatusConfig(data.complianceStatus);

    return {
        ...query,
        widgets: {
            readinessScore: Number(data.readinessScore) || 0,
            reviewItems: Number(data.reviewItems) || 0,
            compliance: {
                title: t('Compliance Status'),
                status: {
                    label: t(complianceConfig.label),
                    color: complianceConfig.color,
                },
                cardStyle: {
                    backgroundColor: complianceConfig.backgroundColor,
                    borderColor: complianceConfig.borderColor,
                },
            },
            readinessPercentage: {
                title: t('Readiness Score'),
                value: `${Number(data.readinessPercentage) || 0}%`,
            },
            activeSuppliers: {
                title: t('Active Suppliers'),
                value: Number(data.activeSuppliers) || 0,
            },
            lastUpdated: {
                title: t('Last Updated'),
                value: data.lastUpdated
                    ? dateUtils.convertDateToDate(data.lastUpdated, PPWR_LAST_UPDATED_DATE_FORMAT)
                    : '—',
            },
        },
    };
};

export default useSummaryWidgets;
